import { ApiClient } from './client';
import type { BackofficeCategory, Category, CategoryStatus } from '@/types/category.types';

export interface CreateCategoryPayload {
  name: string;
  nameTranslation?: string;
  slug?: string;
  description?: string;
  descriptionTranslation?: string;
  icon?: string;
}

export interface UpdateCategoryPayload {
  name?: string;
  nameTranslation?: string | null;
  description?: string | null;
  descriptionTranslation?: string | null;
  icon?: string | null;
  status?: CategoryStatus;
}

export const categoriesAPI = {
  /** Catálogo público — solo categorías active. Consumido por onboarding y Settings. */
  list: async (): Promise<Category[]> => {
    const res = await ApiClient.get<{ items: Category[] }>('/categories');
    return res.items;
  },

  // ── Backoffice ──

  listAll: async (status?: CategoryStatus | 'all'): Promise<BackofficeCategory[]> => {
    const q = status ? `?status=${encodeURIComponent(status)}` : '';
    const res = await ApiClient.get<{ items: BackofficeCategory[] }>(`/backoffice/categories${q}`);
    return res.items;
  },

  create: async (payload: CreateCategoryPayload): Promise<BackofficeCategory> => {
    return ApiClient.post<BackofficeCategory>('/backoffice/categories', payload);
  },

  update: async (id: string, payload: UpdateCategoryPayload): Promise<BackofficeCategory> => {
    return ApiClient.patch<BackofficeCategory>(`/backoffice/categories/${encodeURIComponent(id)}`, payload);
  },

  remove: async (id: string): Promise<void> => {
    await ApiClient.delete<void>(`/backoffice/categories/${encodeURIComponent(id)}`);
  },

  regenerateTranslation: async (id: string): Promise<BackofficeCategory> => {
    return ApiClient.post<BackofficeCategory>(
      `/backoffice/categories/${encodeURIComponent(id)}/regenerate-translation`,
    );
  },
};
